import React from 'react'
import { useTranslation } from 'react-i18next'
import { DoSelects } from '@dogoo/do-selects'
import { useMainAppContext } from '../../../../hooks/useMainAppContext'

const DG_TreeSelect_Department = (props) => {
    const { t } = useTranslation()
    const { departmentData } = useMainAppContext()

    const setDepartmentTree = (parentId, departments) => {
        if (departments?.length === 0) return null
        const childDepartments = departments.filter((department) => {
            if (!props.all)
                return (
                    department.parentId === parentId &&
                    department.status === 'approved'
                )
            else return department.parentId === parentId
        })

        return childDepartments.map((department) => ({
            key: department.id,
            value: department.id,
            type: department.type,
            title: renderTitle(department.name),
            name: department.name,

            children: setDepartmentTree(department.id, departments),
            disabled: department.status !== 'approved'
        }))
    }
    const style = {
        width: props.width || '200px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
    const renderTitle = (title) => {
        return (
            <div title={title} style={style}>
                {title}
            </div>
        )
    }

    return (
        <DoSelects
            data={departmentData}
            selectType={'department'}
            maxTagCount={'responsive'}
            style={{ width: '100%' }}
            all
            placeholder={t('tnp.components.common.text4')}
            {...props}
        />
    )
}

export default DG_TreeSelect_Department
